import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { categories, getComicsByCategory } from '@/mocks/comics';

const categoryMeta: Record<string, { title: string; description: string; keywords: string }> = {
  korean: {
    title: '韩漫 - 可乐漫画 | 韩国漫画大全 | 热门韩漫免费在线看',
    description: '可乐漫画韩漫频道，精选数百部韩国漫画，包含热血、恋爱、奇幻、穿越等多种类型。好看的韩漫推荐，热门韩漫免费看，高清画质，流畅阅读体验。',
    keywords: '韩漫, 韩国漫画, 好看的韩漫, 韩漫推荐, 热门韩漫, 免费韩漫, 韩漫大全, 在线看韩漫',
  },
  japanese: {
    title: '日漫 - 可乐漫画 | 日本漫画大全 | 热门日漫免费在线看',
    description: '可乐漫画日漫频道，汇集经典与最新的日本漫画，涵盖热血、校园、奇幻、悬疑等丰富类型。热门日漫免费在线看，高清画质流畅阅读。',
    keywords: '日漫, 日本漫画, 好看的日漫, 日漫推荐, 热门日漫, 免费日漫, 日漫大全, 在线看日漫',
  },
  chinese: {
    title: '国漫 - 可乐漫画 | 国产漫画大全 | 热门国漫免费在线看',
    description: '可乐漫画国漫频道，精挑细选国产漫画佳作，古风武侠、奇幻冒险、都市恋爱应有尽有。热门国漫推荐，免费国漫在线看，支持国漫崛起。',
    keywords: '国漫, 国产漫画, 好看的国漫, 国漫推荐, 热门国漫, 免费国漫, 国漫大全, 在线看国漫',
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'korean');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const meta = categoryMeta[activeSlug] || categoryMeta.korean;
  const catInfo = categories.find(c => c.slug === activeSlug);
  const comics = getComicsByCategory(activeSlug);

  return (
    <>
      <SEOHead
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        canonicalUrl={`https://kelecomic.com/category/${activeSlug}`}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-6">
              <Breadcrumb />
              <div className="py-8">
                <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
                  {catInfo?.name || '漫画分类'}
                </h1>
                <p className="text-sm text-foreground-500 mt-2">{meta.description.slice(0, 80)}...</p>
              </div>
            </div>
          </div>

          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <span className="mr-1.5">
                    <i className={cat.icon}></i>
                  </span>
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
              {comics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>

            {comics.length === 0 && (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 mb-4">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画，敬请期待</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}